var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-badge',{staticClass:"width-badge",attrs:{"pill":"","variant":_vm.variant}},[_vm._v(_vm._s(_vm.statusMsg))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }